var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "content_box beforetab" }, [
      _c(
        "div",
        { staticClass: "popup_dim", attrs: { id: "schLT_popup" } },
        [
          _vm.customComponentLT
            ? _c(_vm.customComponentLT, {
                tag: "component",
                attrs: { "parent-info": _vm.parentInfo },
                on: { close: _vm.closePopup },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("form", { attrs: { id: "frm2" } }, [
        _c("div", { staticClass: "border_bottom_gray_box" }, [
          _c("table", { staticClass: "tbl_search" }, [
            _vm._m(0),
            _c("tbody", [
              _c("tr", [
                _c("th", [_vm._v(_vm._s(_vm.$t("msg.VOSD100.002")))]),
                _c(
                  "td",
                  [
                    _c("e-auto-complete-place", {
                      attrs: {
                        id: "polPol",
                        "ctr-cd": _vm.pol.ctrCd,
                        "plc-cd": _vm.pol.plcCd,
                        "is-char": true,
                        "is-char-alert": true,
                      },
                      on: { change: _vm.changePol },
                    }),
                  ],
                  1
                ),
                _c("th", [
                  _c("span", { staticClass: "ml20" }, [
                    _vm._v(_vm._s(_vm.$t("msg.VOSD100.003"))),
                  ]),
                ]),
                _c(
                  "td",
                  [
                    _c("e-auto-complete-place", {
                      attrs: {
                        id: "podPod",
                        "ctr-cd": _vm.pod.ctrCd,
                        "plc-cd": _vm.pod.plcCd,
                        "is-char": true,
                        "is-char-alert": true,
                      },
                      on: { change: _vm.changePod },
                    }),
                  ],
                  1
                ),
                _c("td", { staticClass: "pr0 text-right" }, [
                  _c("span", [
                    _c(
                      "button",
                      {
                        staticClass: "tbl_icon plus",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openSection.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("plus")]
                    ),
                  ]),
                ]),
              ]),
              _c(
                "tr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.section2nd === "Y",
                      expression: "section2nd ==='Y'",
                    },
                  ],
                },
                [
                  _c("th", [_vm._v(_vm._s(_vm.$t("msg.VOSD100.002")))]),
                  _c(
                    "td",
                    [
                      _c("e-auto-complete-place", {
                        attrs: {
                          id: "polPol2",
                          "ctr-cd": _vm.pol2.ctrCd,
                          "plc-cd": _vm.pol2.plcCd,
                        },
                        on: { change: _vm.changePol2 },
                      }),
                    ],
                    1
                  ),
                  _c("th", [
                    _c("span", { staticClass: "ml20" }, [
                      _vm._v(_vm._s(_vm.$t("msg.VOSD100.003"))),
                    ]),
                  ]),
                  _c(
                    "td",
                    [
                      _c("e-auto-complete-place", {
                        attrs: {
                          id: "podPod2",
                          "ctr-cd": _vm.pod2.ctrCd,
                          "plc-cd": _vm.pod2.plcCd,
                        },
                        on: { change: _vm.changePod2 },
                      }),
                    ],
                    1
                  ),
                  _c("td", { staticClass: "pr0 text-right" }, [
                    _c("span", [
                      _c(
                        "button",
                        {
                          staticClass: "tbl_icon minus",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.close2ndSection.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("minus")]
                      ),
                    ]),
                  ]),
                ]
              ),
              _c(
                "tr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.section3rd === "Y",
                      expression: "section3rd ==='Y'",
                    },
                  ],
                },
                [
                  _c("th", [_vm._v(_vm._s(_vm.$t("msg.VOSD100.002")))]),
                  _c(
                    "td",
                    [
                      _c("e-auto-complete-place", {
                        attrs: {
                          id: "polPol3",
                          "ctr-cd": _vm.pol3.ctrCd,
                          "plc-cd": _vm.pol3.plcCd,
                        },
                        on: { change: _vm.changePol3 },
                      }),
                    ],
                    1
                  ),
                  _c("th", [
                    _c("span", { staticClass: "ml20" }, [
                      _vm._v(_vm._s(_vm.$t("msg.VOSD100.003"))),
                    ]),
                  ]),
                  _c(
                    "td",
                    [
                      _c("e-auto-complete-place", {
                        attrs: {
                          id: "podPod3",
                          "ctr-cd": _vm.pod3.ctrCd,
                          "plc-cd": _vm.pod3.plcCd,
                        },
                        on: { change: _vm.changePod3 },
                      }),
                    ],
                    1
                  ),
                  _c("td", { staticClass: "pr0 text-right" }, [
                    _c("span", [
                      _c(
                        "button",
                        {
                          staticClass: "tbl_icon minus",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.close3rdSestion.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("minus")]
                      ),
                    ]),
                  ]),
                ]
              ),
              _c("tr", [
                _c("th", [_vm._v(_vm._s(_vm.$t("msg.VOSD100.008")))]),
                _c("td", { attrs: { colspan: "4" } }, [
                  _c("span", [
                    _c(
                      "div",
                      { staticClass: "input_calendar" },
                      [
                        _c("e-month-picker2", {
                          model: {
                            value: _vm.yyyymm,
                            callback: function ($$v) {
                              _vm.yyyymm = $$v
                            },
                            expression: "yyyymm",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      { staticClass: "wid20 d_inline_block text_center" },
                      [_vm._v("~")]
                    ),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.weeks,
                            expression: "weeks",
                          },
                        ],
                        staticClass: "wid104",
                        attrs: { name: "", id: "" },
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.weeks = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            _vm.changeWeeks,
                          ],
                        },
                      },
                      [
                        _c("option", { attrs: { value: "1" } }, [
                          _vm._v("1 Week"),
                        ]),
                        _c("option", { attrs: { value: "2" } }, [
                          _vm._v("2 Week"),
                        ]),
                        _c("option", { attrs: { value: "4" } }, [
                          _vm._v("1 Month"),
                        ]),
                        _c("option", { attrs: { value: "8" } }, [
                          _vm._v("2 Month"),
                        ]),
                        _c("option", { attrs: { value: "12" } }, [
                          _vm._v("3 Month"),
                        ]),
                      ]
                    ),
                  ]),
                  _c("span", { staticClass: "ml20" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.paramBound,
                          expression: "paramBound",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        id: "trad21",
                        name: "trad2",
                        value: "O",
                        checked: "checked",
                      },
                      domProps: { checked: _vm._q(_vm.paramBound, "O") },
                      on: {
                        change: function ($event) {
                          _vm.paramBound = "O"
                        },
                      },
                    }),
                    _c(
                      "label",
                      { staticClass: "mr10", attrs: { for: "trad21" } },
                      [_c("span"), _vm._v(_vm._s(_vm.$t("msg.VOSD100_M3.008")))]
                    ),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.paramBound,
                          expression: "paramBound",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        id: "trad22",
                        name: "trad2",
                        value: "I",
                      },
                      domProps: { checked: _vm._q(_vm.paramBound, "I") },
                      on: {
                        change: function ($event) {
                          _vm.paramBound = "I"
                        },
                      },
                    }),
                    _c(
                      "label",
                      { staticClass: "mr10", attrs: { for: "trad22" } },
                      [_c("span"), _vm._v(_vm._s(_vm.$t("msg.VOSD100_M3.007")))]
                    ),
                  ]),
                  _c(
                    "span",
                    { staticClass: "pr0", staticStyle: { float: "right" } },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.checkBkg,
                            expression: "checkBkg",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "bk3",
                          name: "bk",
                          "true-value": "Y",
                          "false-value": "N",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.checkBkg)
                            ? _vm._i(_vm.checkBkg, null) > -1
                            : _vm._q(_vm.checkBkg, "Y"),
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.checkBkg,
                              $$el = $event.target,
                              $$c = $$el.checked ? "Y" : "N"
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.checkBkg = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.checkBkg = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.checkBkg = $$c
                            }
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "bk3" } }, [
                        _c("span"),
                        _vm._v(_vm._s(_vm.$t("msg.VOSD100_M5.013"))),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _c("tr", [
                _c("th", [_vm._v(_vm._s(_vm.$t("msg.VOSD100.062")))]),
                _c("td", [
                  _c("span", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.sortBin,
                          expression: "sortBin",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        id: "sort11",
                        name: "sort1",
                        value: "E",
                        checked: "checked",
                      },
                      domProps: { checked: _vm._q(_vm.sortBin, "E") },
                      on: {
                        change: function ($event) {
                          _vm.sortBin = "E"
                        },
                      },
                    }),
                    _vm._m(1),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.sortBin,
                          expression: "sortBin",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        id: "sort12",
                        name: "sort1",
                        value: "D",
                      },
                      domProps: { checked: _vm._q(_vm.sortBin, "D") },
                      on: {
                        change: function ($event) {
                          _vm.sortBin = "D"
                        },
                      },
                    }),
                    _vm._m(2),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.sortBin,
                          expression: "sortBin",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        id: "sort13",
                        name: "sort1",
                        value: "T",
                      },
                      domProps: { checked: _vm._q(_vm.sortBin, "T") },
                      on: {
                        change: function ($event) {
                          _vm.sortBin = "T"
                        },
                      },
                    }),
                    _vm._m(3),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.sortBin,
                          expression: "sortBin",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        id: "sort14",
                        name: "sort1",
                        value: "C",
                      },
                      domProps: { checked: _vm._q(_vm.sortBin, "C") },
                      on: {
                        change: function ($event) {
                          _vm.sortBin = "C"
                        },
                      },
                    }),
                    _c(
                      "label",
                      { staticClass: "mr10", attrs: { for: "sort14" } },
                      [_c("span"), _vm._v(_vm._s(_vm.$t("msg.VOSD100.064")))]
                    ),
                  ]),
                ]),
                _c("th", [_vm._v(_vm._s(_vm.$t("msg.VOSD100.063")))]),
                _c("td", [
                  _c("span", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.sortBy,
                          expression: "sortBy",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        id: "sort21",
                        name: "sort2",
                        value: "A",
                        checked: "checked",
                      },
                      domProps: { checked: _vm._q(_vm.sortBy, "A") },
                      on: {
                        change: function ($event) {
                          _vm.sortBy = "A"
                        },
                      },
                    }),
                    _c(
                      "label",
                      { staticClass: "mr10", attrs: { for: "sort21" } },
                      [_c("span"), _vm._v(_vm._s(_vm.$t("msg.VOSD100.065")))]
                    ),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.sortBy,
                          expression: "sortBy",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        id: "sort22",
                        name: "sort2",
                        value: "D",
                      },
                      domProps: { checked: _vm._q(_vm.sortBy, "D") },
                      on: {
                        change: function ($event) {
                          _vm.sortBy = "D"
                        },
                      },
                    }),
                    _c(
                      "label",
                      { staticClass: "mr10", attrs: { for: "sort22" } },
                      [_c("span"), _vm._v(_vm._s(_vm.$t("msg.VOSD100.066")))]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "border_bottom_gray_box border_bottom_none" },
          [
            _vm.$ekmtcCommon.isNotEmpty(_vm.userCtrCd)
              ? _c("p", { staticClass: "tit_label ml10" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.clickMySchedule,
                        expression: "clickMySchedule",
                      },
                    ],
                    attrs: {
                      type: "checkbox",
                      id: "myschtit2",
                      name: "myschtit2",
                      "true-value": "Y",
                      "false-value": "N",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.clickMySchedule)
                        ? _vm._i(_vm.clickMySchedule, null) > -1
                        : _vm._q(_vm.clickMySchedule, "Y"),
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.clickMySchedule,
                          $$el = $event.target,
                          $$c = $$el.checked ? "Y" : "N"
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.clickMySchedule = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.clickMySchedule = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.clickMySchedule = $$c
                        }
                      },
                    },
                  }),
                  _c("label", { attrs: { for: "myschtit2" } }, [
                    _c("span"),
                    _vm._v(_vm._s(_vm.$t("msg.VOSD100_M5.014"))),
                  ]),
                ])
              : _vm._e(),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.clickMySchedule === "Y",
                    expression: "clickMySchedule === 'Y'",
                  },
                ],
                staticClass: "ml10",
                staticStyle: { display: "block" },
              },
              [
                _c(
                  "ul",
                  { staticClass: "my_sche" },
                  _vm._l(_vm.myScheduleList, function (list, index) {
                    return _c("li", { key: index }, [
                      _c("input", {
                        attrs: {
                          type: "radio",
                          id: list.schId + "LT",
                          name: "mysch2",
                        },
                        domProps: {
                          value: list.schId,
                          checked: list.schId === _vm.schId,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.selectMySchedule(list)
                          },
                        },
                      }),
                      _c("label", { attrs: { for: list.schId + "LT" } }, [
                        _c("span"),
                        _vm._v(
                          _vm._s(list.polNm2) + " - " + _vm._s(list.podNm2)
                        ),
                      ]),
                      _c(
                        "span",
                        { staticClass: "d_inline_block valign_top ml10 mt2" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "tbl_icon delete",
                              on: {
                                click: function ($event) {
                                  return _vm.fnDeleteMySchedule(list.schId)
                                },
                              },
                            },
                            [_vm._v("delete")]
                          ),
                        ]
                      ),
                    ])
                  }),
                  0
                ),
              ]
            ),
          ]
        ),
        _c("div", { staticClass: "position_relative" }, [
          _c(
            "span",
            {
              staticClass: "position_absolute",
              staticStyle: { right: "0", bottom: "0" },
            },
            [
              _c(
                "a",
                {
                  staticClass: "button blue sh",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.getLongTermSchdule.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("msg.VOSD100_M5.107")))]
              ),
            ]
          ),
        ]),
      ]),
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.listSchedule4List.length !== 0,
            expression: "listSchedule4List.length !== 0",
          },
        ],
        staticClass: "content_box mt10",
      },
      [
        _c("div", { staticClass: "wrap_schedule" }, [
          _c("div", { staticClass: "schedule_top" }, [
            _c(
              "div",
              { staticClass: "sail_area" },
              [
                _vm._l(_vm.startPlcNameSel, function (list, i) {
                  return _c("p", { key: i + "PT", staticClass: "port" }, [
                    _c("span", [
                      _c(
                        "a",
                        {
                          class:
                            "port " +
                            (_vm.idxPort !== i ? "color_lightgray" : ""),
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.selectPort(i)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.startPlcNameSel[i]))]
                      ),
                    ]),
                    _c("span", [
                      _c(
                        "a",
                        {
                          class:
                            "port " +
                            (_vm.idxPort !== i ? "color_lightgray" : ""),
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.selectPort(i)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.destPlcNameSel[i]))]
                      ),
                    ]),
                    _vm.$ekmtcCommon.isNotEmpty(_vm.userCtrCd)
                      ? _c("span", { staticClass: "icon" }, [
                          _vm.$ekmtcCommon.isEmpty(
                            _vm.checkMySchList[i].myScheduleOrNot
                          ) || _vm.checkMySchList[i].myScheduleOrNot === "N"
                            ? _c("div", [
                                _c("button", {
                                  staticClass: "tbl_icon myschedule",
                                  on: {
                                    click: function ($event) {
                                      return _vm.fnAddMySchedule(i)
                                    },
                                  },
                                }),
                              ])
                            : _c("div", [
                                _c("button", {
                                  staticClass: "tbl_icon myschedule on",
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteMyScheduleStar(
                                        _vm.checkMySchList[i].schId
                                      )
                                    },
                                  },
                                }),
                              ]),
                        ])
                      : _vm._e(),
                  ])
                }),
                _vm._l(_vm.voyCntVoList, function (list, index) {
                  return _c("ul", { key: index }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.idxPort === index,
                            expression: "idxPort === index",
                          },
                        ],
                      },
                      [
                        _c("li", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("msg.VOSD100_M5.016"))),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "num" }, [
                            _vm._v(_vm._s(list.monCnt)),
                          ]),
                        ]),
                        _c("li", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("msg.VOSD100_M5.017"))),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "num" }, [
                            _vm._v(_vm._s(list.tueCnt)),
                          ]),
                        ]),
                        _c("li", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("msg.VOSD100_M5.018"))),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "num" }, [
                            _vm._v(_vm._s(list.wedCnt)),
                          ]),
                        ]),
                        _c("li", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("msg.VOSD100_M5.019"))),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "num" }, [
                            _vm._v(_vm._s(list.thuCnt)),
                          ]),
                        ]),
                        _c("li", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("msg.VOSD100_M5.020"))),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "num" }, [
                            _vm._v(_vm._s(list.friCnt)),
                          ]),
                        ]),
                        _c("li", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("msg.VOSD100_M5.021"))),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "num" }, [
                            _vm._v(_vm._s(list.satCnt)),
                          ]),
                        ]),
                        _c("li", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("msg.VOSD100_M5.022"))),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "num" }, [
                            _vm._v(_vm._s(list.sunCnt)),
                          ]),
                        ]),
                        _c("li", { staticClass: "week" }, [
                          _c("span", { staticClass: "week" }, [
                            _vm._v(_vm._s(_vm.$t("msg.VOSD100_M5.031"))),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "num" }, [
                            _vm._v(_vm._s(list.voyCntSum)),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("msg.VOSD100_M5.023"))),
                          ]),
                        ]),
                      ]
                    ),
                  ])
                }),
                _c("div", { staticClass: "btn_area" }, [
                  _c("span", [
                    _c(
                      "a",
                      {
                        staticClass: "button sm",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openPopup("EmailSchedulePop")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("msg.VOSD100.040")))]
                    ),
                  ]),
                  _c("span", [
                    _c(
                      "a",
                      {
                        staticClass: "button sm",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openPopup("EmailPop")
                          },
                        },
                      },
                      [_vm._v("email")]
                    ),
                  ]),
                  _c("span", [
                    _c(
                      "a",
                      {
                        staticClass: "button sm",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.excelDownload()
                          },
                        },
                      },
                      [_vm._v("Download")]
                    ),
                  ]),
                ]),
              ],
              2
            ),
            _c("div", { staticClass: "date_area" }, [
              _c(
                "div",
                { staticClass: "remark", staticStyle: { width: "22%" } },
                [
                  _c("span", { staticClass: "finish" }, [
                    _vm._v(_vm._s(_vm.$t("msg.CSBL100_M1.017"))),
                  ]),
                  _c("span", { staticClass: "possible" }, [
                    _vm._v(_vm._s(_vm.$t("msg.CSBL100_M1.013"))),
                  ]),
                  _c("span", { staticClass: "after" }, [
                    _vm._v(_vm._s(_vm.$t("msg.VOSD100_M5.024"))),
                  ]),
                ]
              ),
              _c("div", { staticClass: "date" }, [
                _c("span", [
                  _c(
                    "a",
                    {
                      staticClass: "prev",
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.fnChangeCalendar(_vm.prevMonth)
                        },
                      },
                    },
                    [_vm._v("prev")]
                  ),
                ]),
                _c("span", { staticClass: "year" }, [
                  _vm._v(_vm._s(_vm.currentYear)),
                ]),
                _c("span", { staticClass: "month" }, [
                  _vm._v(_vm._s(_vm.currentMonth)),
                ]),
                _c("span", [
                  _c(
                    "a",
                    {
                      staticClass: "next",
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.fnChangeCalendar(_vm.nextMonth)
                        },
                      },
                    },
                    [_vm._v("next")]
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "sc_list_type" }, [
            _c(
              "table",
              { staticClass: "tbl_col" },
              [
                _c("colgroup", [
                  _c("col", { staticStyle: { width: "7%" } }),
                  _c("col", { staticStyle: { width: "15%" } }),
                  _c("col", { staticStyle: { width: "auto" } }),
                  _c("col", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.bound === "O",
                        expression: "bound === 'O'",
                      },
                    ],
                    staticStyle: { width: "24%" },
                  }),
                  _c("col", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.bound === "I",
                        expression: "bound === 'I'",
                      },
                    ],
                    staticStyle: { width: "34%" },
                  }),
                  _c("col", { staticStyle: { width: "10%" } }),
                  _c("col", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.bound === "O",
                        expression: "bound === 'O'",
                      },
                    ],
                    staticStyle: { width: "12%" },
                  }),
                  _c("col", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.bound === "O",
                        expression: "bound === 'O'",
                      },
                    ],
                    staticStyle: { width: "8%" },
                  }),
                ]),
                _c("thead", [
                  _c("tr", [
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.$t("msg.CMBA100.00154"))),
                    ]),
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.$t("msg.VOSD100_M4.005"))),
                    ]),
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.$t("msg.VOSD100.002"))),
                    ]),
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.$t("msg.VOSD100.003"))),
                    ]),
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.$t("msg.CSBL100_M1.015"))),
                    ]),
                    _c(
                      "th",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.bound === "O",
                            expression: "bound === 'O'",
                          },
                        ],
                        attrs: { scope: "col" },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("msg.VOSD100_M4.009")) +
                            "/" +
                            _vm._s(_vm.$t("msg.VOSD100_M4.010")) +
                            _vm._s(_vm.cyOpenYn === "Y" ? " /CY Open" : "")
                        ),
                      ]
                    ),
                    _c(
                      "th",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.bound === "O",
                            expression: "bound === 'O'",
                          },
                        ],
                        attrs: { scope: "col" },
                      },
                      [_vm._v("Booking")]
                    ),
                  ]),
                ]),
                _vm._l(_vm.listSchedule4List, function (schedule, schIdx) {
                  return _c("tbody", { key: schIdx }, [
                    (schedule.orgTs || schedule.ts) === "Y" &&
                    schIdx >= _vm.startIdx &&
                    schIdx < _vm.endIdx
                      ? _c("tr", [
                          _c("td", { attrs: { rowspan: "10" } }, [
                            _vm._v(
                              _vm._s(schedule.ts === "Y" ? "T/S" : "Direct")
                            ),
                          ]),
                          _c(
                            "td",
                            {
                              staticClass: "text_left",
                              attrs: { rowspan: "2" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(schedule.vslNm1) +
                                  " " +
                                  _vm._s(schedule.voyNo)
                              ),
                              _c("br"),
                              _vm._v(
                                "(Route : " + _vm._s(schedule.rteCd) + ") "
                              ),
                            ]
                          ),
                          _c("td", [
                            _vm._v(" " + _vm._s(schedule.polNm) + " "),
                          ]),
                          _c("td", [
                            _vm._v(" " + _vm._s(schedule.pol2Nm) + " "),
                          ]),
                          _c("td", { attrs: { rowspan: "2" } }, [
                            _c("ul", [
                              _c("li", [_vm._v(_vm._s(schedule.transitTime1))]),
                            ]),
                          ]),
                          _c(
                            "td",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.bound === "O",
                                  expression: "bound === 'O'",
                                },
                              ],
                              attrs: { rowspan: schedule.tsDegree * 2 },
                            },
                            [
                              _c("ul", [
                                _c("li", [
                                  _vm._v(
                                    _vm._s(
                                      schedule.bkgDocCls !== ""
                                        ? _vm.changeDateTime2Display(
                                            schedule.bkgDocCls,
                                            _vm.lang
                                          )
                                        : " "
                                    )
                                  ),
                                ]),
                                _c("li", [
                                  _vm._v(
                                    _vm._s(
                                      schedule.bkgCgoCls !== ""
                                        ? _vm.changeDateTime2Display(
                                            schedule.bkgCgoCls,
                                            _vm.lang
                                          )
                                        : " "
                                    )
                                  ),
                                ]),
                                _vm.cyOpenYn === "Y"
                                  ? _c("li", [
                                      _vm._v(
                                        _vm._s(
                                          !!schedule?.cyOpenDate &&
                                            schedule.cyOpenDate !== ""
                                            ? _vm.changeDateTime2Display(
                                                schedule.cyOpenDate,
                                                _vm.lang
                                              )
                                            : " "
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                          _c(
                            "td",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.bound === "O",
                                  expression: "bound === 'O'",
                                },
                              ],
                              staticClass: "color_red",
                              attrs: { rowspan: schedule.tsDegree * 2 },
                            },
                            [
                              schedule.bkgClose === "Y"
                                ? _c("div", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("msg.CSBL100_M1.017"))
                                    ),
                                  ])
                                : schedule.bkgClose !== "M"
                                ? _c("div", [
                                    _c("ul", [
                                      _c("li", { staticClass: "mt5" }, [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "button sm blue",
                                            on: {
                                              click: function ($event) {
                                                return _vm.bookingBooking4List(
                                                  schedule
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Booking")]
                                        ),
                                      ]),
                                    ]),
                                  ])
                                : _c("div", [_vm._v(" - ")]),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    (schedule.orgTs || schedule.ts) === "Y" &&
                    schIdx >= _vm.startIdx &&
                    schIdx < _vm.endIdx
                      ? _c("tr", [
                          _c("td", { staticClass: "bor-left" }, [
                            _c("ul", [
                              _c("li", [
                                _vm._v(_vm._s(_vm.$t("msg.VOSD100_M2.003"))),
                                _vm._v(
                                  " : " +
                                    _vm._s(
                                      _vm.changeDate2Display(
                                        schedule.polEtb,
                                        schedule.polEtbTm,
                                        _vm.lang
                                      )
                                    )
                                ),
                              ]),
                              _c("li", [
                                _vm._v(_vm._s(_vm.$t("msg.VOSD100_M2.004"))),
                                _vm._v(
                                  " : " +
                                    _vm._s(
                                      _vm.changeDate2Display(
                                        schedule.etd,
                                        schedule.etdTm,
                                        _vm.lang
                                      )
                                    )
                                ),
                              ]),
                              _c("li", [
                                _vm._v(
                                  _vm._s(
                                    _vm.fnTrmlText(
                                      schedule.otrmlCd,
                                      schedule.otrmlNm
                                    )
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                          _c("td", [
                            _c("ul", [
                              _c("li", [
                                _vm._v(_vm._s(_vm.$t("msg.VOSD100_M2.003"))),
                                _vm._v(
                                  " : " +
                                    _vm._s(
                                      _vm.changeDate2Display(
                                        schedule.podEtd1,
                                        schedule.etaTm1,
                                        _vm.lang
                                      )
                                    )
                                ),
                              ]),
                              _c("li", [
                                _vm._v(
                                  _vm._s(
                                    _vm.fnTrmlText(
                                      schedule.podTrml1,
                                      schedule.podTrml1Nm
                                    )
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    (schedule.orgTs || schedule.ts) === "Y" &&
                    schIdx >= _vm.startIdx &&
                    schIdx < _vm.endIdx
                      ? _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text_left bor-left",
                              attrs: { rowspan: "2" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(schedule.vslNm2) +
                                  " " +
                                  _vm._s(schedule.voyNo2)
                              ),
                              _c("br"),
                              _vm._v(
                                "(Route : " + _vm._s(schedule.rteCd2) + ") "
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        schedule.tsDegree === "2" &&
                                        schedule.vessel2ndButton === "Y",
                                      expression:
                                        "schedule.tsDegree === '2' && schedule.vessel2ndButton === 'Y'",
                                    },
                                  ],
                                  staticClass: "mt5",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "button sm",
                                      on: {
                                        click: function ($event) {
                                          return _vm.change2ndVessel4List(
                                            schedule,
                                            schIdx
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("msg.VOSD100_M5.027")) +
                                          " "
                                      ),
                                      _c("span", {
                                        staticClass: "btn_icon icoup",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c("td", [
                            _vm._v(" " + _vm._s(schedule.pod1Nm) + " "),
                          ]),
                          _c("td", [
                            _vm._v(" " + _vm._s(schedule.pod2Nm) + " "),
                          ]),
                          _c("td", { attrs: { rowspan: "2" } }, [
                            _c("ul", [
                              _c("li", [_vm._v(_vm._s(schedule.transitTime2))]),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    (schedule.orgTs || schedule.ts) === "Y" &&
                    schIdx >= _vm.startIdx &&
                    schIdx < _vm.endIdx
                      ? _c("tr", [
                          _c("td", { staticClass: "bor-left" }, [
                            _c("ul", [
                              _c("li", [
                                _vm._v(_vm._s(_vm.$t("msg.VOSD100_M2.004"))),
                                _vm._v(
                                  " : " +
                                    _vm._s(
                                      _vm.changeDate2Display(
                                        schedule.polEtd2,
                                        schedule.etdTm2,
                                        _vm.lang
                                      )
                                    )
                                ),
                              ]),
                              _c("li", [
                                _vm._v(
                                  _vm._s(
                                    _vm.fnTrmlText(
                                      schedule.polTrml2,
                                      schedule.polTrml2Nm
                                    )
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                          _c("td", [
                            _c("ul", [
                              _c("li", [
                                _vm._v(_vm._s(_vm.$t("msg.VOSD100_M2.003"))),
                                _vm._v(
                                  " : " +
                                    _vm._s(
                                      _vm.changeDate2Display(
                                        schedule.podEtd2,
                                        schedule.etaTm2,
                                        _vm.lang
                                      )
                                    )
                                ),
                              ]),
                              _c("li", [
                                _vm._v(
                                  _vm._s(
                                    _vm.fnTrmlText(
                                      schedule.podTrml2,
                                      schedule.podTrml2Nm
                                    )
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    (schedule.orgTs || schedule.ts) === "Y" &&
                    schedule.tsDegree >= 3 &&
                    schIdx >= _vm.startIdx &&
                    schIdx < _vm.endIdx
                      ? _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text_left bor-left",
                              attrs: { rowspan: "2" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(schedule.vslNm3) +
                                  " " +
                                  _vm._s(schedule.voyNo3)
                              ),
                              _c("br"),
                              _vm._v(
                                "(Route : " + _vm._s(schedule.rteCd3) + ") "
                              ),
                            ]
                          ),
                          _c("td", [
                            _vm._v(" " + _vm._s(schedule.pod2Nm) + " "),
                          ]),
                          _c("td", [
                            _vm._v(" " + _vm._s(schedule.pod3Nm) + " "),
                          ]),
                          _c("td", { attrs: { rowspan: "2" } }, [
                            _c("ul", [
                              _c("li", [_vm._v(_vm._s(schedule.transitTime3))]),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    (schedule.orgTs || schedule.ts) === "Y" &&
                    schedule.tsDegree >= 3 &&
                    schIdx >= _vm.startIdx &&
                    schIdx < _vm.endIdx
                      ? _c("tr", [
                          _c("td", { staticClass: "bor-left" }, [
                            _c("ul", [
                              _c("li", [
                                _vm._v(_vm._s(_vm.$t("msg.VOSD100_M2.004"))),
                                _vm._v(
                                  " : " +
                                    _vm._s(
                                      _vm.changeDate2Display(
                                        schedule.polEtd3,
                                        schedule.etdTm3,
                                        _vm.lang
                                      )
                                    )
                                ),
                              ]),
                              _c("li", [
                                _vm._v(
                                  _vm._s(
                                    _vm.fnTrmlText(
                                      schedule.polTrml3,
                                      schedule.polTrml3Nm
                                    )
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                          _c("td", [
                            _c("ul", [
                              _c("li", [
                                _vm._v(_vm._s(_vm.$t("msg.VOSD100_M2.003"))),
                                _vm._v(
                                  " : " +
                                    _vm._s(
                                      _vm.changeDate2Display(
                                        schedule.podEtd3,
                                        schedule.etaTm3,
                                        _vm.lang
                                      )
                                    )
                                ),
                              ]),
                              _c("li", [
                                _vm._v(
                                  _vm._s(
                                    _vm.fnTrmlText(
                                      schedule.podTrml3,
                                      schedule.podTrml3Nm
                                    )
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    (schedule.orgTs || schedule.ts) === "Y" &&
                    schedule.tsDegree >= 4 &&
                    schIdx >= _vm.startIdx &&
                    schIdx < _vm.endIdx
                      ? _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text_left bor-left",
                              attrs: { rowspan: "2" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(schedule.vslNm4) +
                                  " " +
                                  _vm._s(schedule.voyNo4)
                              ),
                              _c("br"),
                              _vm._v(
                                "(Route : " + _vm._s(schedule.rteCd4) + ") "
                              ),
                            ]
                          ),
                          _c("td", [
                            _vm._v(" " + _vm._s(schedule.pod3Nm) + " "),
                          ]),
                          _c("td", [
                            _vm._v(" " + _vm._s(schedule.pod4Nm) + " "),
                          ]),
                          _c("td", { attrs: { rowspan: "2" } }, [
                            _c("ul", [
                              _c("li", [_vm._v(_vm._s(schedule.transitTime4))]),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    (schedule.orgTs || schedule.ts) === "Y" &&
                    schedule.tsDegree >= 4 &&
                    schIdx >= _vm.startIdx &&
                    schIdx < _vm.endIdx
                      ? _c("tr", [
                          _c("td", { staticClass: "bor-left" }, [
                            _c("ul", [
                              _c("li", [
                                _vm._v(_vm._s(_vm.$t("msg.VOSD100_M2.004"))),
                                _vm._v(
                                  " : " +
                                    _vm._s(
                                      _vm.changeDate2Display(
                                        schedule.polEtd4,
                                        schedule.etdTm4,
                                        _vm.lang
                                      )
                                    )
                                ),
                              ]),
                              _c("li", [
                                _vm._v(
                                  _vm._s(
                                    _vm.fnTrmlText(
                                      schedule.polTrml4,
                                      schedule.polTrml4Nm
                                    )
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                          _c("td", [
                            _c("ul", [
                              _c("li", [
                                _vm._v(_vm._s(_vm.$t("msg.VOSD100_M2.003"))),
                                _vm._v(
                                  " : " +
                                    _vm._s(
                                      _vm.changeDate2Display(
                                        schedule.podEtd4,
                                        schedule.etaTm4,
                                        _vm.lang
                                      )
                                    )
                                ),
                              ]),
                              _c("li", [
                                _vm._v(
                                  _vm._s(
                                    _vm.fnTrmlText(
                                      schedule.podTrml4,
                                      schedule.podTrml4Nm
                                    )
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _c(
                      "tr",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.show2ndVessel === "Y" &&
                              schIdx === _vm.listIndexNo,
                            expression:
                              "show2ndVessel === 'Y' && schIdx === listIndexNo",
                          },
                        ],
                        attrs: { id: "vessel2nd" + schIdx },
                      },
                      [
                        _c(
                          "td",
                          {
                            staticClass: "bor-left pd0",
                            attrs: { colspan: "6" },
                          },
                          [
                            _c("div", { staticClass: "inner_table" }, [
                              _c("div", { staticClass: "port_info" }, [
                                _c("p", { staticClass: "port t2" }, [
                                  _c("span", [_vm._v(_vm._s(schedule.polNm))]),
                                  _c("span", [_vm._v(_vm._s(schedule.podNm))]),
                                ]),
                                _c("p", { staticClass: "txt_desc none" }, [
                                  _vm._v(_vm._s(_vm.$t("msg.VOSD100_M5.028"))),
                                ]),
                                _c("div", { staticClass: "btn_port_cancel" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "button sm gray",
                                      on: {
                                        click: function ($event) {
                                          return _vm.cancel2ndVessel4List(
                                            schIdx
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("msg.VOSD100_M5.029"))
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _c(
                                "table",
                                { staticClass: "tbl_col t2 tac mt10" },
                                [
                                  _vm._m(4, true),
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", [
                                        _vm._v(
                                          _vm._s(_vm.$t("menu.MENU09.060"))
                                        ),
                                      ]),
                                      _c("th", [_vm._v("ETD")]),
                                      _c("th", [_vm._v("ETA")]),
                                      _c("th", [
                                        _vm._v(
                                          _vm._s(_vm.$t("msg.CSBL100_M1.015"))
                                        ),
                                      ]),
                                      _c("th", [
                                        _vm._v(
                                          _vm._s(_vm.$t("msg.CSBL200.075"))
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.vessel2ndList,
                                      function (list, idx) {
                                        return _c("tr", { key: idx }, [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(list.vslNm) +
                                                " " +
                                                _vm._s(list.voyNo)
                                            ),
                                          ]),
                                          _c("td", [
                                            _vm._v(_vm._s(list.etdStrDT)),
                                          ]),
                                          _c("td", [
                                            _vm._v(_vm._s(list.etaStrDT)),
                                          ]),
                                          _c("td", [
                                            _vm._v(_vm._s(list.transitTime)),
                                          ]),
                                          _c("td", [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "button gray sm",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.select2ndVessel4List(
                                                      list,
                                                      schIdx
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("msg.CSBL200.075")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    (schedule.orgTs || schedule.ts) !== "Y" &&
                    schIdx >= _vm.startIdx &&
                    schIdx < _vm.endIdx
                      ? _c("tr", [
                          _c("td", { attrs: { rowspan: "2" } }, [
                            _vm._v("Direct"),
                          ]),
                          _c(
                            "td",
                            {
                              staticClass: "text_left",
                              attrs: { rowspan: "2" },
                            },
                            [
                              _vm._v(
                                _vm._s(schedule.vslNm) +
                                  " " +
                                  _vm._s(schedule.voyNo)
                              ),
                              _c("br"),
                              _vm._v(
                                "(Route : " + _vm._s(schedule.rteCd) + ")"
                              ),
                            ]
                          ),
                          _c("td", [
                            _vm._v(" " + _vm._s(schedule.polNm) + " "),
                          ]),
                          _c("td", [
                            _vm._v(" " + _vm._s(schedule.podNm) + " "),
                          ]),
                          _c("td", { attrs: { rowspan: "2" } }, [
                            _c("ul", [
                              _c("li", [_vm._v(_vm._s(schedule.transitTime))]),
                            ]),
                          ]),
                          _c(
                            "td",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.bound === "O",
                                  expression: "bound === 'O'",
                                },
                              ],
                              attrs: { rowspan: "2" },
                            },
                            [
                              _c("ul", [
                                _c("li", [
                                  _vm._v(
                                    _vm._s(
                                      schedule.bkgDocCls !== ""
                                        ? _vm.changeDateTime2Display(
                                            schedule.bkgDocCls,
                                            _vm.lang
                                          )
                                        : " "
                                    )
                                  ),
                                ]),
                                _c("li", [
                                  _vm._v(
                                    _vm._s(
                                      schedule.bkgCgoCls !== ""
                                        ? _vm.changeDateTime2Display(
                                            schedule.bkgCgoCls,
                                            _vm.lang
                                          )
                                        : " "
                                    )
                                  ),
                                ]),
                                _vm.cyOpenYn === "Y"
                                  ? _c("li", [
                                      _vm._v(
                                        _vm._s(
                                          !!schedule?.cyOpenDate &&
                                            schedule.cyOpenDate !== ""
                                            ? _vm.changeDateTime2Display(
                                                schedule.cyOpenDate,
                                                _vm.lang
                                              )
                                            : " "
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                          _c(
                            "td",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.bound === "O",
                                  expression: "bound === 'O'",
                                },
                              ],
                              staticClass: "color_red",
                              attrs: { rowspan: "2" },
                            },
                            [
                              schedule.bkgClose === "Y"
                                ? _c("div", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("msg.CSBL100_M1.017"))
                                    ),
                                  ])
                                : schedule.bkgClose !== "M"
                                ? _c("div", [
                                    _c("ul", [
                                      _c("li", { staticClass: "mt5" }, [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "button sm blue",
                                            on: {
                                              click: function ($event) {
                                                return _vm.bookingBooking4List(
                                                  schedule
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Booking")]
                                        ),
                                      ]),
                                    ]),
                                  ])
                                : _c("div", [_vm._v(" - ")]),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    (schedule.orgTs || schedule.ts) !== "Y" &&
                    schIdx >= _vm.startIdx &&
                    schIdx < _vm.endIdx
                      ? _c("tr", [
                          _c("td", { staticClass: "bor-left" }, [
                            _c("ul", [
                              _c("li", [
                                _vm._v(_vm._s(_vm.$t("msg.VOSD100_M2.003"))),
                                _vm._v(
                                  " : " +
                                    _vm._s(
                                      _vm.changeDate2Display(
                                        schedule.polEtb,
                                        schedule.polEtbTm,
                                        _vm.lang
                                      )
                                    )
                                ),
                              ]),
                              _c("li", [
                                _vm._v(_vm._s(_vm.$t("msg.VOSD100_M2.004"))),
                                _vm._v(
                                  " : " +
                                    _vm._s(
                                      _vm.changeDate2Display(
                                        schedule.etd,
                                        schedule.etdTm,
                                        _vm.lang
                                      )
                                    )
                                ),
                              ]),
                              _c("li", [
                                _vm._v(
                                  _vm._s(schedule.otrmlCd) +
                                    " (" +
                                    _vm._s(schedule.otrmlNm) +
                                    ")"
                                ),
                              ]),
                            ]),
                          ]),
                          _c("td", [
                            _c("ul", [
                              _c("li", [
                                _vm._v(_vm._s(_vm.$t("msg.VOSD100_M2.003"))),
                                _vm._v(
                                  " : " +
                                    _vm._s(
                                      _vm.changeDate2Display(
                                        schedule.eta,
                                        schedule.etaTm,
                                        _vm.lang
                                      )
                                    )
                                ),
                              ]),
                              _c("li", [
                                _vm._v(
                                  _vm._s(schedule.itrmlCd) +
                                    " (" +
                                    _vm._s(schedule.itrmlNm) +
                                    ")"
                                ),
                              ]),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ])
                }),
              ],
              2
            ),
            _vm.pagingList.length > 0
              ? _c(
                  "div",
                  { staticClass: "paging" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "btn prev",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.getList4Schedule(_vm.curPage - 1)
                          },
                        },
                      },
                      [_vm._v(" Prev ")]
                    ),
                    _vm._l(_vm.pagingList, function (idx) {
                      return _c(
                        "a",
                        {
                          key: idx,
                          class: [idx === _vm.curPage ? "on" : ""],
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.getList4Schedule(idx)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(idx) + " ")]
                      )
                    }),
                    _c(
                      "a",
                      {
                        staticClass: "btn next",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.getList4Schedule(_vm.curPage + 1)
                          },
                        },
                      },
                      [_vm._v(" Next ")]
                    ),
                  ],
                  2
                )
              : _vm._e(),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "90px" } }),
      _c("col"),
      _c("col", { attrs: { width: "90px" } }),
      _c("col"),
      _vm._v(" "),
      _c("col", { attrs: { width: "60px" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "mr10", attrs: { for: "sort11" } }, [
      _c("span"),
      _vm._v("ETD"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "mr10", attrs: { for: "sort12" } }, [
      _c("span"),
      _vm._v("Direct/TS"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "mr10", attrs: { for: "sort13" } }, [
      _c("span"),
      _vm._v("T/T"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "24%" } }),
      _c("col", { attrs: { width: "24%" } }),
      _c("col", { attrs: { width: "24%" } }),
      _c("col", { attrs: { width: "18%" } }),
      _c("col", { attrs: { width: "10%" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }